// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"1ae2df5e","243":"3f3041f0","832":"738326b8","859":"1378680c"}[chunkId] + ".chunk.js";
};